import { render, staticRenderFns } from "./NewCoverageArea.vue?vue&type=template&id=b8dc22c8"
import script from "./NewCoverageArea.vue?vue&type=script&lang=js"
export * from "./NewCoverageArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports